import * as React from 'react';
import { format } from 'date-fns';
import { Popover, PopoverContent, PopoverTrigger } from '../Popover';
import { Button } from '../Button';
import { cn } from '../../../../utils/styles';
import { Calendar } from '../Calendar';
import Icons from '../../Icons/Icons';

interface DatePickerProps {
  prefix?: string;
  date: Date;
  onSelect?: (data: Date | undefined) => void;
  icon?: React.ReactNode;
  className?: string;
}

function DatePicker({ prefix, onSelect, date, icon, className }: DatePickerProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className={cn(
            'justify-start text-left min-w-[150px] !leading-[14px] text-addition1 text-sm ' +
              'px-[10px] py-[7px] h-[50px]',
            {
              'text-muted-foreground': !date,
            },
            className,
          )}
        >
          <div>
            {prefix ? <div className="leading-[14px] text-[12px] opacity-50 mb-[2px]">{prefix}</div> : null}
            {date ? format(date, 'MMM dd, yyyy') : <span>Pick a date</span>}
          </div>
          {icon || <Icons.Calendar className="ml-[15px] h-[20px] w-[18px]" />}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" selected={date} defaultMonth={date} onSelect={onSelect} withYearPicker />
      </PopoverContent>
    </Popover>
  );
}

DatePicker.defaultProps = {
  prefix: undefined,
  icon: undefined,
  className: '',
  onSelect: () => undefined,
};

export default DatePicker;
